<i18n>
{
	"en": {
		"cancelLabel": "Cancel",
		"chooseDriver": "Select Driver",
		"name": "Name",
		"phone": "Phone",
		"email": "Mail",
		"searchPlaceholder": "Search text",
		"title": "Search for Driver"
	},
	"no": {
		"cancelLabel": "Avbryt",
		"chooseDriver": "Velg Sjåfør",
		"name": "Navn",
		"phone": "Telefon",
		"email": "E-post",
		"searchPlaceholder": "Søketekst",
		"title": "Søk etter sjåfør"
	}
}
</i18n>
<template>
	<t-dialog
		:icon="icon"
		:isShown="isShown"
		:title="$t('title')"
		:confirmLabel="$t('chooseDriver')"
		:cancelLabel="$t('cancelLabel')"
		:isConfirmDisabled="selectedDriver === undefined"
		iconType="bp"
		focusFirstOnShow
		:keyListeners="getKeyListeners()"
		@close="onClose"
		@ok="onOk"
		@shown="onShown"
	>
		<t-form-group>

			<t-search-input
				ref="input"
				v-model="searchValue"
				:placeholder="$t('searchPlaceholder')"
			/>

			<t-grid
				v-if="showGrid"
				ref="grid"
				:items="filteredItems"
				:columnDefinitions="columnDefinitions"
				:defaultColumnDefinition="defaultColumnDefinition"
				:rowHeight="40"
				:showFilters="false"
				:singleSelect="true"
				:selectableMode="['row']"
				selectable
				style="height: 400px; width: 500px;"
				:selectedItems="selectedDrivers"
				@selected="setSelectedDriver"
				@enter="onEnter"
				@rowDoubleClick="selectAndClose"
			/>
		</t-form-group>
		<div slot="additional-buttons">
			<NewDriverButton @ok="onNewDriver"/>
		</div>
	</t-dialog>
</template>

<script>
import { mapState, mapActions } from '../store/drivers.store.js';
import NewDriverButton from '@/modules/drivers/NewDriverButton';
import TDialog from '@/components/evergreen/overlays/TDialog';
import TGrid from '@/components/evergreen/timpex/grid/TGrid';
export default {
	components: {
		TGrid,
		TDialog,
		NewDriverButton,
	},
	props: {
		icon: String,
		isShown: Boolean,
		initialSearchValue: String
	},
	data() {
		return {
			searchValue: '',
			showGrid: false,
			selectedDriver: undefined,
			isNewDriverDialogShown: false,
			defaultColumnDefinition: { resizable: false, }
		};
	},
	computed: {
		...mapState(['drivers']),
		selectedDrivers() {
			return this.selectedDriver ? [this.selectedDriver] : [];
		},
		filteredItems() {
			if (!this.searchValue || this.searchValue === '') return this.drivers;
			return this.drivers.filter(item => this.filterItem(item, this.searchValue));
		},
		columnDefinitions() {
			return [
				{
					field: 'name',
					displayName: this.$t('name'),
					minWidth: 150,
					resizable: true,
				},
				{
					field: 'phoneNumber',
					displayName: this.$t('phone'),
					width: 110,
				},
				{
					field: 'email',
					displayName: this.$t('email'),
					width: 150,
				}
			];
		}
	},
	async mounted() {
		await this.getDrivers();
	},
	methods: {
		...mapActions(['getDrivers']),
		onShown() {
			if (this.initialSearchValue) {
				this.searchValue = this.initialSearchValue;
			}
			this.showGrid = true;
		},
		getKeyListeners() {
			return [
				{
					key: 'F3',
					listener: this.onF3,
					modifiers: { shiftKey: undefined, ctrlKey: false, altKey: false, stop: true, prevent: true }
				},
			];
		},
		onF3() {
			if (!this.$refs.grid || !this.showGrid) return;

			let input = this.$refs.input.$el.querySelector('input:not([tabindex="-1"])');

			if (this.$refs.grid.getFocusedIndex() >= 0) {

				input.focus();
				this.$refs.grid.removeFocus();

			} else {
				input.blur();

				this.$refs.grid.focusGrid();
				this.$refs.grid.focusFirst();
			}
		},

		filterItem(item, searchString) {
			if (!item) return false;
			let ret = true;
			for (let c of searchString.split(' ')) {
				ret = ret &&
					( (item.name && item.name.toLowerCase().includes(c.toLowerCase()))
					|| ( item.phoneNumber && item.phoneNumber.toString().toLowerCase().includes(c.toLowerCase()) )
					|| ( item.email && item.email.toString().toLowerCase().includes(c.toLowerCase()) )
					);
			}
			return ret;
		},
		selectAndClose(driverId) {
			if (!driverId) return;
			this.selectedDriver = this.drivers.find( x => x.id === driverId);
			this.onOk();
			this.onClose();
		},
		onEnter() {
			if (!this.selectedDriver) return;
			this.onOk();
			this.onClose();
		},
		setSelectedDriver(driverIds) {
			if (!driverIds) return;
			let driver = this.drivers.find(x => x.id === driverIds[0]);
			this.selectedDriver = driver;
		},
		onClose() {
			this.$emit('close');
			this.selectedDriver = undefined;
			this.searchValue = '';
			this.showGrid = false;
		},
		onOk() {
			this.$emit('ok', this.selectedDriver);
			this.selectedDriver = undefined;
			this.searchValue = '';
			this.showGrid = false;
		},
		async onNewDriver(newDriver) {
			await this.getDrivers();
			this.selectedDriver = newDriver.id;
			this.searchValue = newDriver.name;
		}
	}
};
</script>

<style>

</style>
